import { getVarName } from '../helpers';
import { GumParseObject } from '../models';
/**
 * Generates CSS variables based on the object
 * @param values CSS values object
 * @param prefix prefix for CSS variable name
 */
export const generateObjectValues: GumParseObject = (values, prefix) => {
  const newValues: string[] = [];

  for (const key in values) {
    if (values.hasOwnProperty(key)) {
      newValues.push(`${getVarName(prefix, key)}: ${values[key]};`);
    }
  }

  return newValues;
};
